const ENDataSource = {
	"Adicionar Origem": "Add Origin",
	"Alterar Origem": "Change Origin",
	"Configuração é requerida": "Configuration is required",
	"Deseja realmente excluir a origem de dados": "Do you really want to delete the data origin",
	"Erro ao adicionar origem de dados": "Error adding data origin",
	"Erro ao alterar origem de dados": "Error changing data origin",
	"Erro ao excluir origem de dados": "Error deleting data origin",
	"Exclusão de origem de dados": "Deletion of data origin",
	"Nova Origem": "New Origin",
	"Modelo": "Model",
	"Mostrar configuração avançada": "Show advanced configuration",
	"Mostrar modelo": "Show model",
	"Ocultar configuração avançada": "Hide advanced configuration",
	"Ocultar modelo": "Hide model",
	"Origem de dados adicionada com sucesso": "Data origin successfully added",
	"Origem de dados alterada com sucesso": "Data origin changed successfully",
	"Origem de dados excluída com sucesso": "Data origin successfully deleted",
	"Origem de dados": "Data Origin"
};

export default ENDataSource;
